import { Component, inject } from "@angular/core";
import { RouterModule } from "@angular/router";
import { NgxSpinnerComponent } from "ngx-spinner";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "app-root",
    imports: [RouterModule, NgxSpinnerComponent],
    templateUrl: "./app.component.html",
    styleUrl: "./app.component.scss",
})
export class AppComponent {
    private translate = inject(TranslateService);

    constructor() {
        this.translate.use(localStorage.getItem("locale") || "en");
    }
}
